import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  useDisclosure,
  Input,
  useToast,
  Flex,
} from '@chakra-ui/react'
import React from 'react'
import { api, baseURL } from '../../../../services/api'
import { useMutation } from 'react-query'

async function updateStatusAcompanhaCompras({ codusu, numero_nota, nunota, codprod, sequencia }) {
  const codUsuario = JSON.parse(localStorage.getItem('authentication')).codigo_usuario

  const parametro = {
    cod_usu: codUsuario,
    numero_nota: numero_nota,
    nunota: nunota,
    codprod: codprod,
    sequencia: sequencia,
  }

  const response = await baseURL.post('/pedido/atualiza-status-compra-acompanhamento', parametro)

  return response.data
}

async function validateNf(pedido_venda, pedido_compra, codigo_nota, quantidade, cod_prod) {
  const response = await api.post('/site/v2/pedido/verifica-nfe-service', {
    numero_pedido: pedido_venda,
    numero_nota: pedido_compra,
    chave_nota: codigo_nota,
    quantidade: quantidade ? quantidade : 0,
    pedido_compra: pedido_compra,
    codigo_produto: cod_prod,
  })

  return response.data
}

export function Validation({ item, refresh }) {
  const toast = useToast({
    position: 'top-right',
    duration: 3000,
    isClosable: true,
  })

  console.log(item)

  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = React.useRef()
  const [bipes, setBipes] = React.useState([''])

  function addNewBipe() {
    setBipes((prev) => [...prev, ''])
  }

  function updateBipe(index, value) {
    setBipes((prev) => prev.map((item, i) => (i === index ? value : item)))
  }

  function removeBipe(index) {
    setBipes((prev) => prev.filter((_, i) => i !== index))
  }

  const inputRef = React.useRef()

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: () => validateNf(item.pedido_venda, item.pedido_compra, bipes, item.quantidade_troca, item.cod_prod),
    onError: (error) => {
      const errorMessage = error?.response?.data?.erros

      toast({
        title: 'Erro ao validar nota fiscal',
        description: errorMessage || 'Ocorreu um erro ao validar nota fiscal',
        status: 'error',
      })

      refresh({ pendente_etiqueta: 'S' })
    },
    onSuccess: () => {
      toast({
        title: 'Nota fiscal validada com sucesso',
        status: 'success',
      })

      updateStatusAcompanhaCompras({
        codusu: JSON.parse(localStorage.getItem('authentication')).codigo_usuario,
        numero_nota: [item.numero_nota],
        nunota: [item.numero_nota],
        codprod: [item.cod_prod],
        sequencia: [item.sequencia],
      })

      onClose()
      // refresh({ pendente_etiqueta: 'S' })

      window.location.reload()
    },
  })

  async function handleSubmitValues(e) {
    e.preventDefault()

    try {
      await mutateAsync()
    } catch (error) {
      console.error('Erro ao validar nota fiscal', error)
    }
  }

  return (
    <>
      <Button colorScheme="blue" onClick={onOpen}>
        Validar
      </Button>

      <AlertDialog isOpen={isOpen} leastDestructiveRef={inputRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Validar NF
            </AlertDialogHeader>

            <AlertDialogBody>
              Por favor, bipe a nota fiscal para validar.
              {bipes.map((bipe, index) => (
                <Flex key={index} gap={2} alignItems="center" mt={2}>
                  <Input value={bipe} placeholder="Bipe a nota fiscal" onChange={(e) => updateBipe(index, e.target.value)} />
                  <Button colorScheme="red" onClick={() => removeBipe(index)}>
                    Remover
                  </Button>
                </Flex>
              ))}
              <Button colorScheme="blue" onClick={addNewBipe} mt={2}>
                Adicionar
              </Button>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>
              <Button colorScheme="green" ml={3} onClick={handleSubmitValues} isLoading={isLoading}>
                Validar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
